/* istanbul ignore file */
import React, { lazy } from 'react'

import SiteRoute from '../../components/SiteRoute'

const MongoliaNLIHP = lazy(() => import('./pages/MongoliaNLIHP'))

export default [<SiteRoute key="nlihp" exact path="/" component={MongoliaNLIHP} />]
